import * as React from "react";

import nameof from "ts-nameof.macro";

import { withRouter } from "react-router-dom";
import { Editorial, ColegioCredencialesEditorialesEditModel, ModelValidationResult, TipoAccesoLicencia, TipoUsuario, ContenidosDigitalesColegioSearch, TipoLicencia } from "../models/dataModels";
import { GenericEditState } from "../utils/base/GenericEditState";
import { EditPageBase } from "../utils/base/EditPageBase";
import { IServiceForEdit } from "../utils/base/BaseServices";
import { ColegioCredencialesEditorialesService } from "./ColegioCredencialesEditorialesService";
import { RouteHelper } from "../IntranetRouter";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { I18n } from "../utils/I18n";
import { ModelValidation } from "../utils/base/ModelValidation";
import { EditorialDropDown } from "../helpers/EnumDropDown";
import { UserPasswordIdCentro } from "./UserPasswordIdCentro";
import { TipoAccesoDropDown } from "../licenciasColegio/TipoAccesoDropDown";
import { Lti11ConfigCentro } from "./Lti11ConfigCentro";
import { Lti13ConfigCentro } from "./Lti13ConfigCentro";
import { ContenidosDigitalesColegioSearchEx, ContenidosPicker } from "../contenidos/colegio/Picker";
import { ClientContext } from "../utils/ClientContext";
import { NavigationHelper } from "../utils/base/Breadcrumb";
import { ViewIcon } from "../utils/Icons";

export class EditComp extends EditPageBase<ColegioCredencialesEditorialesEditModel> {

    protected _setPageTitleForNew(): string {
        return "Nuevo"
    }

    protected _setPageTitleForExisting(editModel: ColegioCredencialesEditorialesEditModel): string {
        return `Editar ${editModel.nombre}`;
    }

    protected _createApiService(): IServiceForEdit<ColegioCredencialesEditorialesEditModel> {
        return new ColegioCredencialesEditorialesService();
    }

    protected updateBreadCrumb(model: ColegioCredencialesEditorialesEditModel) {
        var items = [
            {
                text: I18n.Strings.schoolProfile,
                link: RouteHelper.myProfileSchool()
            },
            {
                text: I18n.Strings.colegio.tabCredenciales,
                link: RouteHelper.listCredencialesColegio()
            }
        ];

        if (model.id == 0) {
            items.push({
                text: I18n.Strings.addNew,
                link: ""
            });
        }
        else {
            items.push({
                text: model.nombre,
                link: RouteHelper.editCredenciales(model.id)
            });
        }

        NavigationHelper.setBreadcrumbItems(items);
    }

    protected _generateForm(): JSX.Element {
        return <React.Fragment>
            <Row>
                <Col md={4}>
                    <FormGroup>
                        <Label for={"credenciales" + nameof(this.state.editModel.nombre)}>{I18n.Strings.cursoEscolar.nombre}</Label>
                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.editModel.nombre = evt.target.value;
                                this.setState(state);
                            }}
                            type="text"
                            required={true}
                            maxLength={100}
                            className={"form-control " + this._errorClass(nameof(this.state.editModel.nombre))}
                            name={nameof(this.state.editModel.nombre)}
                            id={"credenciales" + nameof(this.state.editModel.nombre)}
                            value={this.state.editModel.nombre || ""}
                        />
                        {this._errorMessage(nameof(this.state.editModel.nombre))}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <EditorialDropDown
                        emptyText={I18n.Strings.colegiocredenciales.editorial + "..."}
                        label={I18n.Strings.colegiocredenciales.editorial}
                        showLabel={true}
                        id={nameof(this.state.editModel.editorial)}
                        value={this.state.editModel.editorial}
                        required={true}
                        errorMessage={this.state.validationResult.getError(nameof(this.state.editModel.editorial))}
                        onChanged={(value: string) => {
                            var newState = this._cloneStateForSetState();
                            if (value != '') {
                                newState.editModel.editorial = value as Editorial;
                            }
                            else {
                                newState.editModel.editorial = null;
                            }

                            this.setState(newState);
                        }}
                    />
                </Col>
                <Col md={4}>
                    <Label for={"credenciales" + nameof(this.state.editModel.tipoLicencia)}>
                        {I18n.Strings.colegiocredenciales.tipoLicencia}
                    </Label>
                    <TipoAccesoDropDown
                        emptyText={I18n.Strings.colegiocredenciales.tipoLicencia + "..."}
                        editorial={this.state.editModel.editorial}
                        id={nameof(this.state.editModel.tipoLicencia)}
                        value={this.state.editModel.tipoLicencia}
                        onChange={(value: string) => {
                            var newState = this._cloneStateForSetState();
                            if (value != '') {
                                newState.editModel.tipoLicencia = value as TipoAccesoLicencia;
                            }
                            else {
                                newState.editModel.tipoLicencia = null;
                            }
                            this.setState(newState);
                        }}

                    />
                    {this._errorMessage(nameof(this.state.editModel.tipoLicencia))}

                </Col>
            </Row>
            <Row>
                <Col md="12" className="mt-4 mb-3">
                    <h4>Acceso a los contenidos</h4>
                </Col>
            </Row>
            <Row>
                {this.state.editModel.tipoLicencia == TipoAccesoLicencia.Lti11 &&
                    <Lti11ConfigCentro
                        required={true}
                        formValidation={this.state.validationResult}
                        value={this.state.editModel.datos}
                        onChange={(value) => {
                            var state = this._cloneStateForSetState();
                            state.editModel.datos = value;
                            this.setState(state);
                        }}
                    />
                }
                {this.state.editModel.tipoLicencia == TipoAccesoLicencia.Lti13 &&
                    <Lti13ConfigCentro
                        required={true}
                        formValidation={this.state.validationResult}
                        value={this.state.editModel.datos}
                        onChange={(value) => {
                            var state = this._cloneStateForSetState();
                            state.editModel.datos = value;
                            this.setState(state);
                        }}
                    />
                }
                {this.state.editModel.tipoLicencia != TipoAccesoLicencia.Lti11 && this.state.editModel.tipoLicencia != TipoAccesoLicencia.Lti13 &&
                    <>

                    {!(this.state.editModel.editorial == Editorial.Burlington && this.state.editModel.tipoLicencia == TipoAccesoLicencia.Custom)
                            &&
                            <UserPasswordIdCentro
                                required={true}
                                formValidation={this.state.validationResult}
                                value={this.state.editModel.datos}
                                onChange={(value, user, pwd) => {
                                    var state = this._cloneStateForSetState();
                                    state.editModel.datos = value;
                                    this.setState(state);
                                }}
                            />
                        }
                    {(this.state.editModel.editorial == Editorial.Burlington && this.state.editModel.tipoLicencia == TipoAccesoLicencia.Custom)
                            && <>
                                <p>Burlington: credenciales son propias del hub, para utilizarlo simplemente debe guardar este registro</p>
                            </>
                        }
                    </>}
            </Row>

            {(this.state.editModel.tipoLicencia == TipoAccesoLicencia.NoAccedeMuestraMensaje ||
                this.state.editModel.tipoLicencia == TipoAccesoLicencia.NoAccedeNoMuestraCredenciales ||
                this.state.editModel.tipoLicencia == TipoAccesoLicencia.NoAccedeSiMuestraCredenciales ||
                this.state.editModel.tipoLicencia == TipoAccesoLicencia.SantillanaAV4
            ) &&


                <Row>
                    <Col md="12" className="mt-4 mb-3">
                        <Label for={"urlAcceso" + nameof(this.state.editModel.urlAcceso)}>
                            {I18n.Strings.colegiocredenciales.urlAcceso}
                        </Label>
                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.editModel.urlAcceso = evt.target.value;
                                this.setState(state);
                            }}
                            type="text"
                            required={true}
                            maxLength={250}
                            className={"form-control " + this._errorClass(nameof(this.state.editModel.urlAcceso))}
                            name={nameof(this.state.editModel.urlAcceso)}
                            id={"urlAcceso" + nameof(this.state.editModel.urlAcceso)}
                            value={this.state.editModel.urlAcceso || ""}
                        />
                    </Col>
                </Row>
            }

            {/* Mostrar la credencial consiste en interceptar el salto a la plataforma, así que no
                se ofrece en los tipos que no saltan: NoAccedeSiMuestraCredenciales ya las muestra y
                NoAccedeNoMuestraCredenciales significa justo lo contrario. */}
            {(this.state.editModel.tipoLicencia != TipoAccesoLicencia.NoAccedeMuestraMensaje &&
                this.state.editModel.tipoLicencia != TipoAccesoLicencia.NoAccedeNoMuestraCredenciales &&
                this.state.editModel.tipoLicencia != TipoAccesoLicencia.NoAccedeSiMuestraCredenciales
            ) &&
                <Row>
                    <Col md="12" className="mt-4">
                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.editModel.mostrarCredencialAlAcceder = evt.target.checked;
                                this.setState(state);
                            }}
                            type="checkbox"
                            style={{ padding: 0, marginRight: 10 }}
                            name={nameof(this.state.editModel.mostrarCredencialAlAcceder)}
                            id={nameof(this.state.editModel.mostrarCredencialAlAcceder)}
                            checked={this.state.editModel.mostrarCredencialAlAcceder || false}
                        />
                        <Label for={nameof(this.state.editModel.mostrarCredencialAlAcceder)}>
                            {I18n.Strings.colegiocredenciales.mostrarCredencialAlAcceder}
                        </Label>
                        <small className="form-text text-muted">
                            {I18n.Strings.colegiocredenciales.mostrarCredencialAlAccederAyuda}
                        </small>
                    </Col>
                </Row>
            }

            <Row>
                <Col md="12" className="mt-4 mb-3">
                    <FormGroup>
                        <Label for={"credenciales" + nameof(this.state.editModel.mensajeAcceso)}>
                            {I18n.Strings.colegiocredenciales.mensajeAcceso}
                        </Label>
                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.editModel.mensajeAcceso = evt.target.value;
                                this.setState(state);
                            }}
                            type="textarea"
                            maxLength={4000}
                            className={"form-control " + this._errorClass(nameof(this.state.editModel.mensajeAcceso))}
                            name={nameof(this.state.editModel.mensajeAcceso)}
                            id={"credenciales" + nameof(this.state.editModel.mensajeAcceso)}
                            value={this.state.editModel.mensajeAcceso || ""}
                        />
                        <small className="form-text text-muted">
                            {I18n.Strings.colegiocredenciales.mensajeAccesoAyuda}
                        </small>
                        {this._errorMessage(nameof(this.state.editModel.mensajeAcceso))}
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md="12" lg={6} className="mt-4 mb-3">
                    <ContenidosPicker

                        size="xl"
                        required={false}
                        label={<span>
                            {I18n.Strings.licenciasContenido.contenido}
                            {this.state.editModel.contenidoIsbn != null && <> ({this.state.editModel.contenidoIsbn})</>}
                        </span>}
                        itemId={null}
                        itemName={this.state.editModel.contenidoNombre}
                        getIdFromItem={(item) => item.id}
                        disabled={false}
                        mostrarNiveles={true}
                        mostrarSoloColegio={true}
                        key={"contPicker"}
                        nivelEducativoId={null}
                        searchParams={{
                            ...{} as ContenidosDigitalesColegioSearchEx,
                            nivelEducativoId: null,
                            claseId: null,
                            editorial: this.state.editModel.editorial
                        }}
                        getNameFromItem={(item) => {
                            return item.nombre;
                        }}
                        cursoEscolarId={ClientContext.Current.cursoEscolarActivoId}
                        errorMessage={this.state.validationResult.getError(nameof(this.state.editModel.contenidoNombre))}
                        onSelected={(contenidoId, contenido, item) => {

                            // Migración de Contenidos: la clave funcional de la credencial es el
                            // ISBN (CCE.Isbn); el picker devuelve ids de cated.ItemCatalogoEditorial
                            // que no se persisten (la columna legacy ContenidoId se eliminó).
                            var state = this._cloneStateForSetState();
                            state.editModel.contenidoNombre = contenido;
                            state.editModel.contenidoIsbn = item == null ? null : item.isbn;
                            this.setState(state);
                        }}
                    />
                </Col>
            </Row>

            <Row>
                <Col md="12" className="mt-4 mb-3">
                    <h4>Mantenimiento</h4>
                </Col>
            </Row>
            <Row>
                <Col md="12" lg="4">
                    <Input
                        onChange={(evt) => {
                            var state = this._cloneStateForSetState();
                            state.editModel.deshabilitarAcceso = evt.target.checked;
                            if (!state.editModel.deshabilitarAcceso) {
                                state.editModel.mensajeDeshabilitarAcceso = "";
                            }
                            this.setState(state);
                        }}
                        type="checkbox"
                        style={{ padding: 0, marginRight: 10 }}
                        name={nameof(this.state.editModel.deshabilitarAcceso)}
                        id={nameof(this.state.editModel.deshabilitarAcceso)}
                        checked={this.state.editModel.deshabilitarAcceso || false}
                    />
                    <Label for={nameof(this.state.editModel.deshabilitarAcceso)}>{I18n.Strings.colegiocredenciales.deshabilitarAcceso}</Label>
                </Col>

                <Col md="12" lg="8">
                    <FormGroup>
                        <Label for={nameof(this.state.editModel.mensajeDeshabilitarAcceso)}>
                            {I18n.Strings.colegiocredenciales.mensajeDeshabilitarAcceso}
                        </Label>
                        <Input
                            onChange={(evt) => {
                                var state = this._cloneStateForSetState();
                                state.editModel.mensajeDeshabilitarAcceso = evt.target.value;
                                this.setState(state);
                            }}
                            type="textarea"
                            required={this.state.editModel.deshabilitarAcceso}
                            disabled={!this.state.editModel.deshabilitarAcceso}
                            maxLength={500}
                            className={"form-control " + this._errorClass(nameof(this.state.editModel.mensajeDeshabilitarAcceso))}
                            name={nameof(this.state.editModel.mensajeDeshabilitarAcceso)}
                            id={nameof(this.state.editModel.mensajeDeshabilitarAcceso)}
                            value={this.state.editModel.mensajeDeshabilitarAcceso || ""}
                        />
                        {this._errorMessage(nameof(this.state.editModel.mensajeDeshabilitarAcceso))}
                    </FormGroup>
                </Col>

            </Row>
        </React.Fragment>;
    }

    protected _getEditUrl(id: number): string {
        return RouteHelper.editCredenciales(id);
    }

    protected _getListUrl(): string {
        return RouteHelper.listCredencialesColegio();
    }

    protected _createStateForNew(): Promise<GenericEditState<ColegioCredencialesEditorialesEditModel>> {

        var model = new GenericEditState<ColegioCredencialesEditorialesEditModel>();
        model.editModel = {
            id: 0,
            nombre: "",
            editorial: null,
            datos: ""
        } as ColegioCredencialesEditorialesEditModel;

        return Promise.resolve(model);
    }

    protected _validateModelLocal(): ModelValidation {
        let validation = new ModelValidation();

        if ((this.state.editModel.nombre || "").trim().length == 0) {
            validation.addError(nameof(this.state.editModel.nombre), I18n.Strings.validationErrors.valueRequired(I18n.Strings.colegiocredenciales.nombre));
        }

        if (this.state.editModel.editorial == null) {
            validation.addError(nameof(this.state.editModel.editorial), I18n.Strings.validationErrors.valueRequired(I18n.Strings.colegiocredenciales.editorial));
        }

        if (this.state.editModel.deshabilitarAcceso) {
            if ((this.state.editModel.mensajeDeshabilitarAcceso || "").trim().length == 0) {
                validation.addError(nameof(this.state.editModel.mensajeDeshabilitarAcceso), I18n.Strings.validationErrors.valueRequired(I18n.Strings.colegiocredenciales.mensajeDeshabilitarAcceso));
            }
        }

        return validation;
    }

}

export const Edit = withRouter(EditComp)